import { generatePath } from 'react-router-dom';
import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_ASSET_DASHBOARD_By_ID,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_WIDGET_LIST,
} from '../constants';

const api = ({ solutionId, dashboardId, twinId }) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_ASSET_DASHBOARD_By_ID, {
      solutionId,
      dashboardId,
      twinId,
    }),
  });

const WidgetList = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_WIDGET_LIST,
  responseMapping: ResponseMapping.Default,
});

export default WidgetList;
